function Mac() {
	return (
		<div>
			<section className="internal-page-wrapper">
				<div className="container">
					<div className="row h-100 align-items-center justify-content-center text-center">
						<div className="col-12 mt-5">
							<h1 className="font-weight-bold">Music Page</h1>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}
export default Mac;
